import { createStyles } from '@mui/styles';

export const SessionStyle = createStyles({
  root: {
    borderTop: '10px solid #F7F7F7',
    borderBottom: '10px solid #F7F7F7',
    padding: '16px 30px',
    backgroundColor: '#fff',
  },
  head: {
    width: '100%',
  },
  title: {
    fontSize: 16,
    display: 'flex',
    justifyContent: 'center',
    lineHeight: '24px',
    fontWeight: 500,
    fontFamily: 'Inter',
    fontStyle: 'normal',
  },
  subTitleCompleted: {
    fontSize: 12,
    padding: '4px 0px',
    lineHeight: '16px',
    fontWeight: 500,
    display: 'flex',
    justifyContent: 'center',
    color: '#558B2F',
    fontFamily: 'Inter',
    fontStyle: 'normal',
  },
  subTitleStarted: {
    fontSize: 12,
    padding: '4px 0px',
    lineHeight: '16px',
    fontWeight: 500,
    display: 'flex',
    justifyContent: 'center',
    color: '#039BE5',
  },
  buttonContainer: {
    maxWidth: '400px',
    display: 'flex',
    width: '400px',
    bottom: 0,
    padding: '16px',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    paddingRight: '40px',
  },
  message: {
    fontFamily: 'Inter',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0em',
    textAlign: 'center',
    color: '#4E5968',
  },
  subHeader: {
    fontFamily: 'Inter',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '20px',
    padding: '2px',
    color: '#202223',
  },
  message2: {
    fontFamily: 'Inter',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    color: '#202223',
  },
  /** Idle grace screen — matches Figma H2 (28/36) */
  idlingMainHeading: {
    fontFamily: 'Inter',
    fontSize: 28,
    fontWeight: 600,
    lineHeight: '36px',
    textAlign: 'center',
    color: '#202223',
  },
  /** Idle grace screen — matches Figma H5 (18/26), grey subheading */
  idlingSubheading: {
    fontFamily: 'Inter',
    fontSize: 18,
    fontWeight: 600,
    lineHeight: '26px',
    textAlign: 'center',
    color: '#6B7684',
    maxWidth: 327,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  idlingWarningPanel: {
    borderRadius: 8,
    backgroundColor: '#FFF9EB',
    padding: '16px 12px',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  idlingWarningTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  warning: {
    fontWeight: 600,
  },
  failedSession: {
    width: '185px',
    height: '185px',
  },
  buttonWrapper: {
    marginBottom: '24px',
    width: '100%',
  },
  buttonStyles: {
    color: '#ffffff',
    height: 48,
    width: '100%',
    fontSize: '16px',
    fontFamily: 'Inter',
    fontWeight: 600,
    lineHeight: '24px',
    borderRadius: 4,
    textTransform: 'inherit',
    '&:hover': {
      boxShadow: 'none',
    },
  },
});
